<template>
    <div>
        <CDataTable
            :class="`orders report-table ${useFilter ? '' : 'large'}`"
            hover
            :items="list"
            :fields="fields">
            <!-- ID -->
            <template #invoice_id="data">
                <td>{{ data.item.description ? data.item.description : data.item.invoice_id }}</td>
            </template>
            <!-- Дата/время заказа -->
            <template #created_at="data">
                <td>{{ getCreatedAt(data.item.created_at) }}</td>
            </template>
            <!-- Сумма заказа после применения промокода/акции -->
            <template #price="data">
                <td>{{ data.item.price }}</td>
            </template>
            <!-- Комиссия VIP MIRCITY (руб.) -->
            <template #mircity_commission_percent="data">
                <td>{{ partner.commission }}%</td>
            </template>
            <!-- Комиссия VIP MIRCITY (%) -->
            <template #mircity_commission_sum="data">
                <td>{{ getCommission(data.item.price) }}</td>
            </template>
            <!-- Итого к выплате -->
            <template #total="data">
                <td>{{ getTotal(data.item.price) }}</td>
            </template>
            
        </CDataTable>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import countdown from 'countdown';
    require('moment-countdown');

    import { ORDER_STATUS, DELIVERY_TYPE, ORDER_TYPE } from '../../utils/order';
    const {
        orderStatusTitle,
        orderStatusStyle,
        orderTypeTitle,
    } = require('../../utils/order-views');
    const {
        formatDateShort,
        formatTimeShort,
    } = require('../../utils/views');

    export default {
        props: {
            partner: {
                type: Object,
                default: () => {},
            },
            list: {
                type: Array,
                default: () => [],
            },
            orderType: {
                type: String,
                default: 'all',
            },
            useFilter: {
                type: Boolean,
                default: false,
            },
            useSorter: {
                type: Boolean,
                default: false,
            },
            showDifference: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                fieldsAll: [
                    { key: 'invoice_id', label: '№ заказа' },
                    { key: 'created_at', label: 'Дата/время заказа' },
                    { key: 'price', label: 'Фактическая оплата' },
                    { key: 'mircity_commission_percent', label: 'Комиссия VIP MIRCITY (%)' },
                    { key: 'mircity_commission_sum', label: 'Комиссия VIP MIRCITY (руб.)' },
                    // { key: 'refund_for_partner', label: 'Возврат за счет партнера' },
                    // { key: 'refund_for_mircity', label: 'Возврат за счет VIP MIRCITY' },
                    { key: 'total', label: 'Итого к выплате' },
                ],
                // Fields
                fieldsSettings: {},
                settingsModal: false,
                // Sorter
                sorter: '',
                sorterOptions: [
                    { value: '', label: 'Сортировка...' },
                    { value: 'id-asc', label: 'ID: по возрастанию' },
                    { value: 'id-desc', label: 'ID: по убыванию' },
                    { value: 'created_at-asc', label: 'Создан: по возрастанию' },
                    { value: 'created_at-desc', label: 'Создан: по убыванию' },
                    // { value: 'updated_at-asc', label: 'Обновлен: по возрастанию' },
                    // { value: 'updated_at-desc', label: 'Обновлен: по убыванию' },
                    // { value: 'delivery_time-asc', label: 'Доставка: по возрастанию' },
                    // { value: 'delivery_time-desc', label: 'Доставка: по убыванию' },
                    { value: 'price-asc', label: 'Услуги партнера: по возрастанию' },
                    { value: 'price-desc', label: 'Услуги партнера: по убыванию' },
                ],
                // Filters
                showFilters: false,
                filter: {
                    status: null,
                    type: null,
                    tower: null,
                    courier_id: null,
                    concierge_id: null,
                },
                filterOptions: {
                    statuses: [],
                    types: [],
                    towers: [],
                    couriers: [],
                    concierges: [],
                },
            };
        },

        computed: {
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if (item.showDifference && !this.showDifference) {
                        continue;
                    }
                    if(this.adminOnly || !item.admin_only) {
                        if (item.key === 'type') {
                            if (this.orderType === 'all') {
                                if (this.fieldsSettings[item.key]) {
                                    result.push(item);
                                }
                            }
                        } else {
                            if (this.fieldsSettings[item.key]) {
                                result.push(item);
                            }
                        }
                    }
                }
                return result;
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        async created() {
            this.fieldsSettings = this.getFildsSettings();
            this.filterOptions = await this.getFilterOptions();
        },

        methods: {
            orderTypeTitle(orderTypeId, item = {}) {
                if (orderTypeId === ORDER_TYPE.ASSISTANT_HELP) {
                    return 'ПМ';
                }
                if (orderTypeId === ORDER_TYPE.ENTITY_DELIVERY && item?.ed?.items) {
                    const { entity } = item.ed.items[0];
                    return entity.entityType.title.charAt(0);
                }
                return orderTypeTitle(orderTypeId).charAt(0);
            },
            getCreatedAt(created_at) {
                const ca = moment(created_at);
                if (ca.isSame(new Date(), 'day')) {
                    return formatTimeShort(ca.toDate());
                } else {
                    return formatDateShort(ca.toDate());
                }
            },
            getCommission(price) {
                return Math.round(this.partner.commission * price) / 100;
            },
            getTotal(price) {
                return Math.round((100 - this.partner.commission) * price) / 100;
            },
            getUpdatedAt(ISOString) {
                countdown.setLabels(
                    'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                    'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                    ' ',
                    ', '
                );
                const updatedAt = countdown(
                    new Date(ISOString),
                    new Date(),
                    countdown.DAYS | countdown.HOURS | countdown.MINUTES
                ).toString();
                return updatedAt ? updatedAt : 'сейчас';
            },
            getCustomer(customer) {
                let customerInfo = '';
                if (customer.phone) {
                    customerInfo += customer.phone;
                }
                if (customer.firstname) {
                    customerInfo += ' ' + customer.firstname;
                }
                if (customer.lastname) {
                    customerInfo += ' ' + customer.lastname;
                }
                return customerInfo;
            },
            orderStatusTitle(order) {
                if (order.ed?.items?.length) {
                    return orderStatusTitle(
                        order.status,
                        order.type,
                        order.payment_type,
                        order.ed?.items[0]?.entity?.statuses,
                        order.delivery_type
                    );
                }
                return orderStatusTitle(
                    order.status,
                    order.type,
                    order.payment_type,
                    null,
                    order.delivery_type
                );
            },
            orderStatusStyle(orderStatusId, orderType, paymentType) {
                return orderStatusStyle(orderStatusId, orderType, paymentType);
            },
            getDeliveryAddress(item) {
                let address = '';
                if (!item.towerObj && item.address) {
                    address =
                        item.address.street + ' ' + item.address.building + ', ';
                }
                if (item.delivery_type === DELIVERY_TYPE.MEETING_POINT) {
                    address = 'точка встречи';
                } else if (item.delivery_type === DELIVERY_TYPE.WITHOUT) {
                    address = 'без доставки';
                } else if (item.address_details) {
                    address +=
                        'вх. ' +
                        item.address_details.entrance +
                        ', эт. ' +
                        item.address_details.floor +
                        ', оф. ' +
                        item.address_details.appartment;
                }
                return address;
            },
            getTower(item) {
                return item.towerObj
                    ? item.towerObj.short_name
                        ? item.towerObj.short_name
                        : item.towerObj.name
                    : '';
            },
            getCompanies(item) {
                const result = {};
                if (item && item.rd && item.rd.items) {
                    for (const orderItem of item.rd.items) {
                        if (orderItem.restaurant && orderItem.restaurant.id) {
                            result[orderItem.restaurant.id] = {
                                link: '/restaurants/' + orderItem.restaurant.id,
                                title:
                                    (orderItem.restaurant.short_title
                                        ? orderItem.restaurant.short_title
                                        : orderItem.restaurant.title) +
                                    (orderItem.restaurant?.towerObj?.short_name
                                    ? ` (${orderItem.restaurant.towerObj?.short_name})`
                                    : ''),
                            };
                        }
                    }
                } else if (item && item.ed && item.ed.items) {
                    for (const orderItem of item.ed.items) {
                        if (orderItem.entity && orderItem.entity.id) {
                            result[orderItem.entity.id] = {
                                link: `entities/${orderItem.entity.entityType.code}/${orderItem.entity.id}`,
                                title:
                                    (orderItem.entity.short_name
                                        ? orderItem.entity.short_name
                                        : orderItem.entity.title) +
                                    (orderItem.entity?.towerObj?.short_name
                                    ? ` (${orderItem.entity.towerObj?.short_name})`
                                    : ''),
                            };
                        }
                    }
                } else if (item && item.fd && item.fd.items) {
                    for (const orderItem of item.fd.items) {
                        if (orderItem.florist && orderItem.florist.id) {
                            result[orderItem.florist.id] = {
                                link: '/florists/' + orderItem.florist.id,
                                title: orderItem.florist.short_title
                                    ? orderItem.florist.short_title
                                    : orderItem.florist.title,
                            };
                        }
                    }
                } else if (item && item.gd && item.gd.items) {
                    for (const orderItem of item.gd.items) {
                        if (orderItem.grocer && orderItem.grocer.id) {
                            result[orderItem.grocer.id] = {
                                link: '/grocers/' + orderItem.grocer.id,
                                title: orderItem.grocer.short_title
                                    ? orderItem.grocer.short_title
                                    : orderItem.grocer.title,
                            };
                        }
                    }
                } else if (item && item.ld && item.ld.items) {
                    for (const orderItem of item.ld.items) {
                        if (orderItem.laundry && orderItem.laundry.id) {
                            result[orderItem.laundry.id] = {
                                link: '/laundries/' + orderItem.laundry.id,
                                title: orderItem.laundry.short_title
                                    ? orderItem.laundry.short_title
                                    : orderItem.laundry.title,
                            };
                        }
                    }
                } else if (item && item.pd && item.pd.items) {
                    for (const orderItem of item.pd.items) {
                        if (orderItem.pharmacy && orderItem.pharmacy.id) {
                            result[orderItem.pharmacy.id] = {
                                link: '/pharmacies/' + orderItem.pharmacy.id,
                                title: orderItem.pharmacy.short_title
                                    ? orderItem.pharmacy.short_title
                                    : orderItem.pharmacy.title,
                            };
                        }
                    }
                } else if (item && item.ah && item.ah.items) {
                    for (const orderItem of item.ah.items) {
                        if (orderItem.assistant && orderItem.assistant.id) {
                            result[orderItem.assistant.id] = {
                                link: '/assistants/' + orderItem.assistant.id,
                                title: orderItem.assistant.short_title
                                    ? orderItem.assistant.short_title
                                    : orderItem.assistant.title,
                            };
                        }
                    }
                }
                return result;
            },
            getDeliveryTime(item) {
                if (item.delivery_time) {
                    const deliveryTime = formatTimeShort(
                        moment(item.delivery_time).toDate()
                    );
                    if (item.delivery_now) {
                        return `до ${deliveryTime}`;
                    } else {
                        return `<strong>к ${deliveryTime}</strong>`;
                    }
                }
                return '';
            },
            getTimeRemaining(item) {
                var dt = item.delivery_time;
                if (dt) {
                    dt = new moment(dt);
                    let theDate = new Date();
                    if (
                        item.status === ORDER_STATUS.DONE ||
                        item.status === ORDER_STATUS.CANCELED
                    ) {
                        theDate = moment(item.updated_at).toDate();
                        return (
                            (moment(item.updated_at).diff(dt) > 0 ? '- ' : '') +
                            countdown(
                                theDate,
                                new Date(dt.toDate()),
                                countdown.DAYS | countdown.HOURS | countdown.MINUTES
                            )
                        );
                    }
                    return (
                        (moment().diff(dt) > 0 ? '- ' : '') +
                        countdown(
                            theDate,
                            new Date(dt.toDate()),
                            countdown.DAYS | countdown.HOURS | countdown.MINUTES
                        )
                    );
                }
                return '';
            },
            // Fields settings
            getFildsSettings() {
                var fieldsSettings = JSON.parse(
                    localStorage.getItem('report-table-settings')
                );
                if (!fieldsSettings) {
                    fieldsSettings = this.getDefaultFieldsSettings();
                }
                return fieldsSettings;
            },
            getDefaultFieldsSettings() {
                const result = {};
                for (const item of this.fieldsAll) {
                    result[item.key] = true;
                }
                return result;
            },
            setFieldsSettings(fieldsSettings) {
                localStorage.setItem(
                    'orders-table-settings',
                    JSON.stringify(fieldsSettings)
                );
            },
            openSettingsModal() {
                this.settingsModal = true;
            },
            closeSettingsModal() {
                this.setFieldsSettings(this.fieldsSettings);
                this.settingsModal = false;
                this.$forceUpdate();
            },
            resetSorter() {
                this.sorter = '';
            },
            // Filters
            async getFilterOptions() {
                const types = await this.getTypes();
                return {
                    types,
                    statuses: this.getStatuses(),
                    towers: await this.getTowers(),
                    couriers: await this.getCouriers(),
                    concierges: await this.getConcierges(),
                };
            },
            getStatuses() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                for (const status in ORDER_STATUS) {
                    options.push({
                        value: ORDER_STATUS[status],
                        label: orderStatusTitle(ORDER_STATUS[status]),
                    });
                }
                return options;
            },
            async getTypes() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                for (const type in ORDER_TYPE) {
                    options.push({
                        value: ORDER_TYPE[type],
                        label: orderTypeTitle(ORDER_TYPE[type]),
                    });
                }
                const entities = await Vue.axios.get('/entities-type/');
                entities.data.forEach(entity => {
                    const condidate = options.findIndex(filter => filter.value === entity.code);
                    if (condidate === -1) {
                        options.push({
                            value: entity.code,
                            label: entity.title,
                        })
                    } else {
                        options.splice(condidate, 1, {
                            value: entity.code,
                            label: entity.title,
                        });
                    }
                })
                return options.filter(filter => filter.value !== ORDER_TYPE.ENTITY_DELIVERY);
            },
            async getTowers() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/address');
                result.data.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            async getCouriers() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/couriers?pageSize=100');
                result.data.results.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            async getConcierges() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                const result = await Vue.axios.get('/concierges?pageSize=100');
                result.data.results.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },
            resetFilters() {
                this.filter = {
                    status: null,
                    type: null,
                    tower: null,
                    courier_id: null,
                    concierge_id: null,
                };
            },
            cutComment(comment) {
                return `${comment.slice(0, 15)}...`;
            },
            cutDeliveryAddress(address) {
                return `${address.slice(0, 15)}...`;
            }
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.custom-table .position-relative.table-responsive {
    max-height: calc(100vh - 407px);
}
.custom-table.large .position-relative.table-responsive {
    max-height: calc(100vh - 337px);
}

.custom-table table thead th {
    position: sticky;
    box-shadow: 0 0 0 rgba( 0, 0, 0, .3);
    top: -1px;
    background: #fff;
}
.report-table .table thead th {
    /* white-space: nowrap; */
    padding-left: 0;
}
</style>

<style scoped>
.status-cell span {
    display: block;
}
.orders table td,
.orders table th {
    white-space: nowrap;
    padding: 0.1rem;
}
@media (max-width: 576px) {
    .custom-order-1 {
        order: 1;
    }
    .custom-order-2 {
        order: 2;
    }
    .custom-order-3 {
        order: 3;
    }
}
</style>
